import {DEMO_USER_ID, demoImagesById} from '../demoData';
import {cachedExtractImageDataPromise} from './EditorCanvasActions';
import {printImageData, saveImageDataAs} from 'rc-canvas/lib/Utils';
import {fileNameAndType} from '../utils';
import pick from 'lodash/pick';
import each from 'lodash/each';
import {ORIGINAL, POPPED} from '../Constants';

export const OPEN_DEMO_IMAGE = 'OPEN_DEMO_IMAGE';
export const CLOSE_DEMO_IMAGE = 'CLOSE_DEMO_IMAGE';

export const openDemoImage = (id) => {
    return {type: OPEN_DEMO_IMAGE, id, user: {id: DEMO_USER_ID}};
};

export const closeDemoImage = () => {
    return {type: CLOSE_DEMO_IMAGE};
};

export const printDemoImage = (imageInfo, orig = false) => {
    const {src, poppedSrc, width, height} = imageInfo;
    cachedExtractImageDataPromise(orig ? src : poppedSrc, width, height, orig ? 'demo-orig' : 'demo-popped').then(imgData => {
        printImageData(imgData);
    });
};

export const downloadDemoImage = (imageInfo, orig = false, outFileName = null, outType = null) => {
    const {src, poppedSrc, width, height} = imageInfo;
    const {fileName, mimeType} = fileNameAndType({imageInfo, activeImage: orig ? ORIGINAL : POPPED}, outFileName, outType);
    cachedExtractImageDataPromise(orig ? src : poppedSrc, width, height, orig ? 'demo-orig' : 'demo-popped').then(imgData => {
        saveImageDataAs(imgData, fileName, mimeType);
    });
};

export const onPrintDemoSelection = () => (dispatch, getState) => {
    const {demo} = getState().selectedImages;
    const selectedImages = pick(demoImagesById, demo);
    each(selectedImages, (imageInfo) => {
        printDemoImage(imageInfo);
    })
};

export const onDownloadDemoSelection = () => (dispatch, getState) => {
    const {demo} = getState().selectedImages;
    const selectedImages = pick(demoImagesById, demo);
    each(selectedImages, (imageInfo) => {
        downloadDemoImage(imageInfo);
    })
};




// WEBPACK FOOTER //
// ./src/actions/DemoActions.js